import { ReportContext } from './report-grid/model/report-context.model';

export class PrintDialogContent {
    reportContext: ReportContext;
}
